import React from 'react';
import { motion } from 'framer-motion';
export function DifferentiatorSection() {
  return <section className="bg-dark-alt py-24" data-id="element-23">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-24">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.5
      }} data-id="element-25">
          <h2 className="font-display text-3xl md:text-5xl font-bold text-center mb-10 uppercase" data-id="element-26">
            Por qué esto es diferente a todo lo que ya intentaste
          </h2>

          <p className="text-xl text-gray-400 text-center mb-12 max-w-2xl mx-auto" data-id="element-27">
            No requiere fuerza de voluntad. No es contar días. No es una "dieta
            de porno" donde sufres cada momento.
          </p>

          <div className="bg-dark-card border-l-4 border-accent p-8 md:p-10 rounded-r-xl shadow-lg mb-8" data-id="element-28">
            <p className="text-xl md:text-2xl italic text-white leading-relaxed font-medium" data-id="element-29">
              "Tu cerebro no necesita la pornografía. Cree que sí, por años de
              condicionamiento neuroquímico. Una vez que entiendes la trampa, el
              deseo desaparece solo. No por fuerza. Por claridad."
            </p>
          </div>

          <p className="text-center text-gray-500 text-sm uppercase tracking-wider font-bold" data-id="element-30">
            Nota: Incluso puedes seguir viendo porno mientras lees. De hecho, lo
            recomendamos.
          </p>
        </motion.div>
      </div>
    </section>;
}